<template>
  <div class="container-wrapper" v-loading="loading">
    <div class="breadcrumb-wrapper">动态管理</div>

    <div class="search-wrapper">
      <el-form
        :inline="true"
        :model="queryParam"
        label-width="82px"
        class="search-row"
      >
        <el-form-item label="动态ID">
          <el-input
            v-model="queryParam.id"
            placeholder="精确搜索"
            clearable
            style="width: 160px"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input
            v-model="queryParam.userId"
            placeholder="精确搜索"
            clearable
            style="width: 160px"
          ></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input
            v-model="queryParam.nickName"
            placeholder="模糊搜索"
            clearable
            style="width: 160px"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker
            v-model="queryParam.publishTimeStart"
            type="datetime"
            placeholder="时间选择器"
            style="width: 190px"
          ></el-date-picker>
          <span class="range-divider">~</span>
          <el-date-picker
            v-model="queryParam.publishTimeEnd"
            type="datetime"
            placeholder="时间段"
            style="width: 190px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否精选">
          <el-select v-model="queryParam.isHandpick" style="width: 120px">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否置顶">
          <el-select v-model="queryParam.isPinned" style="width: 120px">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号类型" label-width="82px">
          <el-select v-model="queryParam.authorType" style="width: 120px">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="普通用户" :value="1"></el-option>
            <el-option label="马甲号" :value="2"></el-option>
            <el-option label="官方号" :value="3"></el-option>
            <el-option label="校园主理人" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跑步记录">
          <el-select v-model="queryParam.hasRunningRecord" style="width: 120px">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-action-item">
          <el-button @click="clickReset">重置</el-button>
          <el-button type="primary" @click="clickSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="status-tabs">
      <div class="status-tabs-row">
        <div class="status-tab-group">
          <el-button
            v-for="item in statusTabs"
            :key="item.value"
            :class="[
              'status-tab-btn',
              { 'is-active': currentStatus === item.value },
            ]"
            @click="changeStatus(item.value)"
          >
            {{ item.label }}
          </el-button>
        </div>
        <el-button type="primary" class="add-dynamic-btn" @click="goAddDynamic"
          >新增动态</el-button
        >
      </div>
    </div>

    <div class="content-wrapper">
      <el-table
        ref="dynamicTable"
        :data="listData"
        border
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="动态ID"
          min-width="95"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="userId"
          label="用户ID"
          min-width="95"
          align="center"
        >
          <template scope="{ row }">
            <el-button type="text" @click="routeDynamicDetail(row)">
              {{ row.userId }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="nickname"
          label="昵称"
          min-width="110"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="authorTypeText"
          label="类型"
          min-width="95"
          align="center"
        ></el-table-column>
        <el-table-column label="内容" min-width="220" show-overflow-tooltip>
          <template scope="{ row }">
            <span>{{ row.content || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="图片数量/视频时长"
          min-width="168"
          align="center"
        >
          <template scope="{ row }">
            <div
              v-if="!row.videoUrl && !(row.images && row.images.length)"
              class="media-info-cell media-info-cell--empty"
            >
              --
            </div>
            <div v-else class="media-info-cell">
              <div
                v-if="row.videoUrl"
                class="media-thumb-wrap media-thumb--video"
                @click.stop="openVideoPreview(row)"
              >
                <img
                  v-if="row.videoCover"
                  :src="row.videoCover"
                  class="media-thumb"
                  alt=""
                />
                <div v-else class="media-thumb media-thumb--fallback">视频</div>
                <span class="media-play-icon"
                  ><i class="el-icon-caret-right"></i
                ></span>
              </div>
              <div
                v-else-if="row.images && row.images.length"
                class="media-thumb-wrap"
                @click.stop="openImagePreview(row)"
              >
                <img :src="row.images[0]" class="media-thumb" alt="" />
                <span v-if="row.images.length > 1" class="media-thumb-badge"
                  >{{ row.images.length }}张</span
                >
              </div>
              <div class="media-info-value">{{ row.mediaInfoDisplay }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="topicNames"
          label="关联话题"
          min-width="130"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="跑步记录" min-width="220" align="center">
          <template scope="{ row }">
            <div
              v-if="!row.hasRunRecord"
              class="run-record-cell run-record-cell--empty"
            >
              --
            </div>
            <div v-else class="run-record-cell">
              <div class="run-record-line">{{ row.runRecordLine1 }}</div>
              <div class="run-record-line">{{ row.runRecordLine2 }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="publishedAt"
          label="发布时间"
          min-width="175"
          align="center"
          sortable="custom"
        >
          <template scope="{ row }">
            <span>{{ row.publishedAtText }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="shareCount"
          label="分享次数"
          min-width="125"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="likeCount"
          label="点赞数"
          min-width="125"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="commentCount"
          label="评论数"
          min-width="125"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="viewCount"
          label="浏览量"
          min-width="125"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="statusText"
          label="审核状态"
          min-width="95"
          align="center"
        ></el-table-column>
        <el-table-column
          label="驳回原因"
          min-width="140"
          align="center"
          show-overflow-tooltip
        >
          <template scope="{ row }">
            <span>{{ row.auditReasonDisplay }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="isHandpickText"
          label="是否精选"
          min-width="85"
          align="center"
        ></el-table-column>
        <el-table-column label="是否置顶" min-width="190" align="center">
          <template scope="{ row }">
            <div v-if="row.isPinned === 1" class="pin-time-cell">
              <div>是</div>
              <div class="pin-time-line">
                {{ row.pinStartTimeText || "--" }}
              </div>
              <div v-if="row.pinEndTimeText" class="pin-time-line">
                至 {{ row.pinEndTimeText }}
              </div>
            </div>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="240"
          align="center"
          fixed="right"
        >
          <template scope="{ row }">
            <el-button type="text" @click="openSingleAudit(row)"
              >审核</el-button
            >
            <el-button type="text" @click="openSingleHandpick(row)">
              {{ Number(row.isHandpick) === 1 ? "取消精选" : "精选" }}
            </el-button>
            <el-button type="text" @click="openPinDialog(row)">
              {{ Number(row.isPinned) === 1 ? "取消置顶" : "置顶" }}
            </el-button>
            <el-button
              v-if="isDynamicApproved(row)"
              type="text"
              @click="openCommentDialog(row)"
              >评论</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <div class="bottom-action-wrapper">
        <el-button
          type="primary"
          :disabled="selectedRows.length === 0"
          @click="openBatchAuditDialog"
          >批量审核</el-button
        >
        <el-button
          type="primary"
          :disabled="selectedRows.length === 0"
          @click="openBatchHandpickDialog"
          >精选</el-button
        >
      </div>
      <div v-show="total > 0" class="pagination-seq">
        <el-pagination
          layout="total, prev, next"
          :current-page="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="total"
          @current-change="changeCurrentPage"
        >
        </el-pagination>
        <span class="pagination-seq-hint">第 {{ queryParam.pageNum }} 页</span>
      </div>
    </div>

    <el-dialog
      title="动态审核"
      size="tiny"
      :modal-append-to-body="false"
      v-model="auditDialog.visible"
    >
      <el-form label-width="90px">
        <el-form-item label="审核状态">
          <el-select
            v-model="auditDialog.auditStatus"
            style="width: 220px"
            @change="onAuditDialogStatusChange"
          >
            <el-option label="通过" :value="1"></el-option>
            <el-option label="不通过" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="auditDialog.auditStatus === 2"
          label="驳回原因"
          class="audit-reject-form-item"
        >
          <div class="audit-reject-block">
            <el-select
              v-model="auditDialog.rejectReasonKey"
              clearable
              filterable
              placeholder="请选择事由类型（可选）"
              style="width: 100%"
              @change="onAuditRejectReasonKeyChange"
            >
              <el-option
                v-for="opt in auditRejectReasonOptions"
                :key="opt.key"
                :label="opt.label"
                :value="opt.key"
              >
              </el-option>
            </el-select>
            <el-input
              v-if="auditDialog.rejectReasonKey === auditRejectReasonOtherKey"
              v-model="auditDialog.rejectReasonExtra"
              type="textarea"
              :rows="2"
              :maxlength="50"
              placeholder="请输入驳回原因（选填，最多50字）"
              show-word-limit
              class="reject-extra-input"
            >
            </el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="auditDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="submitBatchAudit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="查看图片"
      size="large"
      :modal-append-to-body="false"
      custom-class="dynamic-image-preview-dialog"
      v-model="imagePreview.visible"
      @close="closeImagePreview"
    >
      <div class="image-preview-toolbar" v-if="imagePreview.urls.length > 1">
        <el-button
          size="small"
          icon="el-icon-arrow-left"
          @click="shiftImagePreview(-1)"
          >上一张</el-button
        >
        <span class="image-preview-counter"
          >{{ imagePreview.index + 1 }} / {{ imagePreview.urls.length }}</span
        >
        <el-button
          size="small"
          icon="el-icon-arrow-right"
          @click="shiftImagePreview(1)"
          >下一张</el-button
        >
      </div>
      <div class="image-preview-body">
        <img
          v-if="imagePreview.urls.length"
          :src="imagePreview.urls[imagePreview.index]"
          class="image-preview-img"
          alt=""
        />
      </div>
      <div slot="footer">
        <el-button @click="closeImagePreview">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="播放视频"
      size="large"
      :modal-append-to-body="false"
      custom-class="dynamic-video-preview-dialog"
      v-model="videoPreview.visible"
      @close="closeVideoPreview"
    >
      <video
        v-if="videoPreview.url"
        ref="previewVideo"
        class="video-preview-player"
        :src="videoPreview.url"
        :poster="videoPreview.poster || undefined"
        controls
        playsinline
        webkit-playsinline
      ></video>
      <div slot="footer">
        <el-button @click="closeVideoPreview">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="精选"
      size="tiny"
      :modal-append-to-body="false"
      v-model="handpickDialog.visible"
    >
      <el-form label-width="90px">
        <el-form-item label="是否精选">
          <el-select v-model="handpickDialog.isHandpick" style="width: 220px">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-tip">精选后，符合条件的用户可能在首页看到该动态</div>
      <div slot="footer">
        <el-button @click="handpickDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="submitBatchHandpick">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="置顶"
      :modal-append-to-body="false"
      v-model="pinDialog.visible"
    >
      <el-form label-width="90px">
        <el-form-item label="是否置顶">
          <el-select v-model="pinDialog.isPin" style="width: 220px">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="pinDialog.isPin === 1" label="置顶时间">
          <el-date-picker
            v-model="pinDialog.pinTime"
            type="datetimerange"
            range-separator="至"
            placeholder="请选择开始时间至结束时间"
            style="width: 380px"
          ></el-date-picker>
          <div class="dialog-tip">置顶后，该动态将在APP推荐页的第一个坑位</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="pinDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="pinSubmitting" @click="submitPin"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="评论动态"
      size="small"
      :modal-append-to-body="false"
      custom-class="dynamic-comment-dialog"
      v-model="commentDialog.visible"
      @close="onCommentDialogClose"
    >
      <el-form label-width="82px">
        <el-form-item label="评论账号">
          <div class="form-item-row">
            <div class="form-item-row__col form-item-row__col--author">
              <el-select
                v-model="commentDialog.publishAuthorType"
                style="width: 100%"
                @change="onCommentAuthorTypeChange"
              >
                <el-option label="马甲号" :value="2"></el-option>
                <el-option label="官号" :value="3"></el-option>
                <el-option label="校园主理人" :value="4"></el-option>
              </el-select>
            </div>
            <div class="form-item-row__col form-item-row__col--mode">
              <el-select
                v-model="commentAccountSearchMode"
                style="width: 100%"
                @change="onCommentAccountSearchModeChange"
              >
                <el-option label="昵称" value="name"></el-option>
                <el-option label="用户ID" value="uid"></el-option>
              </el-select>
            </div>
            <div class="form-item-row__col form-item-row__col--grow">
              <el-select
                style="width: 100%"
                clearable
                filterable
                remote
                placeholder="选择用户ID或昵称"
                :loading="commentSelectLoading"
                :remote-method="queryCommentBurnerAccount"
                v-model="commentDialog.publishUid"
                @clear="onCommentAccountSelectClear"
              >
                <el-option
                  v-for="item in commentAccountOptions"
                  :key="item.uid"
                  :label="item.nickName"
                  :value="item.uid"
                >
                  <div class="account-option">
                    <img
                      v-if="item.headImgUrl"
                      class="account-option-avatar"
                      :src="item.headImgUrl"
                      alt=""
                    />
                    <span>{{ item.nickName }}（ID: {{ item.uid }}）</span>
                  </div>
                </el-option>
              </el-select>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="评论内容">
          <el-input
            ref="commentContentInput"
            type="textarea"
            :rows="4"
            :maxlength="500"
            placeholder="请输入"
            v-model="commentDialog.content"
            show-word-limit
          >
          </el-input>
          <div class="comment-emoji-bar">
            <el-button
              type="text"
              class="comment-emoji-trigger"
              @click="commentEmojiPanelVisible = !commentEmojiPanelVisible"
            >
              <span class="comment-emoji-trigger-icon" aria-hidden="true"
                >☺</span
              >
            </el-button>
            <div v-show="commentEmojiPanelVisible" class="comment-emoji-panel">
              <span
                v-for="(emoji, index) in commentEmojiList"
                :key="index"
                class="comment-emoji-item"
                @click="insertCommentEmoji(emoji)"
                >{{ emoji }}</span
              >
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="commentDialog.visible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="commentSubmitting"
          @click="submitComment"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
/** 动态审核弹窗 — 驳回原因日志前缀，便于筛选 */
const LOG_TAG_DYNAMIC_AUDIT = "[DynamicAudit]";
/** 动态评论弹窗 — 日志前缀，便于筛选 */
const LOG_TAG_DYNAMIC_COMMENT = "[DynamicComment]";
/** 审核/精选等写操作成功后，列表刷新延迟（ms），避免接口立即读仍返回旧状态 */
const LIST_REFRESH_AFTER_MUTATION_MS = 1500;
/** 与 DynamicDetail 发布成功一致：返回列表页时延迟再拉列表 */
const SESSION_KEY_DELAY_LIST_REFRESH = "dynamicManage_delayListRefresh";

export default {
  data() {
    return {
      auditRejectReasonOtherKey: "__other__",
      auditRejectReasonOptions: [
        { key: "illegal", label: "发布违规内容" },
        { key: "spam", label: "恶意刷屏 / 灌水" },
        { key: "harass", label: "骚扰 / 攻击他人" },
        { key: "ad", label: "广告 / 引流营销" },
        { key: "low_quality", label: "内容低质 / 抄袭" },
        { key: "__other__", label: "其他（自定义输入）" },
      ],
      loading: false,
      queryParam: this.getDefaultQueryParam(),
      currentStatus: 0,
      total: 0,
      listData: [],
      selectedRows: [],
      statusTabs: [
        { label: "全部", value: 0 },
        { label: "审核中", value: 2 },
        { label: "通过", value: 3 },
        { label: "未通过", value: 4 },
        { label: "待发布", value: 5 },
      ],
      auditDialog: {
        visible: false,
        auditStatus: 1,
        rejectReasonKey: "",
        rejectReasonExtra: "",
      },
      handpickDialog: {
        visible: false,
        isHandpick: 1,
      },
      pinDialog: {
        visible: false,
        dynamicId: null,
        isPin: 1,
        pinTime: "",
      },
      pinSubmitting: false,
      imagePreview: {
        visible: false,
        urls: [],
        index: 0,
      },
      videoPreview: {
        visible: false,
        url: "",
        poster: "",
      },
      commentDialog: {
        visible: false,
        dynamicId: null,
        publishAuthorType: 2,
        publishUid: null,
        content: "",
      },
      commentAccountSearchMode: "name",
      commentSelectLoading: false,
      commentAccountOptions: [],
      commentAccountKeyword: "",
      commentSubmitting: false,
      commentEmojiPanelVisible: false,
      commentEmojiList: [
        "😀",
        "😁",
        "😂",
        "🤣",
        "😊",
        "😍",
        "🥰",
        "😘",
        "😋",
        "🙂",
        "😭",
        "😢",
        "😅",
        "🤔",
        "👍",
        "👏",
        "🙏",
        "👌",
        "💪",
        "🎉",
        "❤️",
        "🔥",
        "✨",
        "🌹",
        "🎈",
        "🍀",
        "☀️",
        "🌙",
        "⭐",
        "💯",
      ],
      _listRefreshTimer: null,
      /** 游标分页：listCursorTrail[i] 为请求第 i+2 页时要传的 nextSearchAfter（由第 i+1 页接口返回） */
      listCursorTrail: [],
      listHasMore: false,
    };
  },

  mounted() {
    try {
      if (
        typeof sessionStorage !== "undefined" &&
        sessionStorage.getItem(SESSION_KEY_DELAY_LIST_REFRESH) === "1"
      ) {
        sessionStorage.removeItem(SESSION_KEY_DELAY_LIST_REFRESH);
        this.queryListAfterMutation();
        return;
      }
    } catch (e) {
      /* ignore */
    }
    this.queryList();
  },

  beforeDestroy() {
    this.clearListRefreshTimer();
  },

  methods: {
    getDefaultQueryParam() {
      return {
        pageNum: 1,
        pageSize: 20,
        id: "",
        userId: "",
        nickName: "",
        publishTimeStart: "",
        publishTimeEnd: "",
        hasRunningRecord: -1,
        isHandpick: -1,
        isPinned: -1,
        authorType: 0,
        sortType: 0,
      };
    },
    isRequestSuccess(errorCode) {
      return errorCode === 10000 || errorCode === 0;
    },
    buildQueryBody() {
      const body = {
        pageNum: this.queryParam.pageNum,
        pageSize: this.queryParam.pageSize,
      };
      const st = Number(this.queryParam.sortType);
      if (!isNaN(st) && st >= 1 && st <= 10) {
        body.sortType = st;
      }
      const id = String(this.queryParam.id || "").trim();
      const userId = String(this.queryParam.userId || "").trim();
      const nickName = String(this.queryParam.nickName || "").trim();
      if (id !== "") {
        body.id = Number(id);
      }
      if (userId !== "") {
        body.userId = Number(userId);
      }
      if (nickName !== "") {
        body.nickName = nickName;
      }
      if (this.queryParam.publishTimeStart) {
        body.publishTimeStart = this.formatDateTime(
          this.queryParam.publishTimeStart
        );
      }
      if (this.queryParam.publishTimeEnd) {
        body.publishTimeEnd = this.formatDateTime(
          this.queryParam.publishTimeEnd
        );
      }
      if (this.queryParam.isHandpick !== -1) {
        body.isHandpick = this.queryParam.isHandpick;
      }
      if (this.queryParam.isPinned !== -1) {
        body.isPinned = this.queryParam.isPinned;
      }
      if (this.queryParam.authorType > 0) {
        body.authorType = this.queryParam.authorType;
      }
      if (this.queryParam.hasRunningRecord > -1) {
        body.hasRunningRecord = this.queryParam.hasRunningRecord;
      }
      if (this.currentStatus > 0) {
        body.status = this.currentStatus;
      }
      const pn = Number(this.queryParam.pageNum);
      if (!isNaN(pn) && pn >= 2) {
        const cursor = this.listCursorTrail[pn - 2];
        if (cursor !== undefined && cursor !== null) {
          body.nextSearchAfter = cursor;
        }
      }
      return body;
    },
    resetListCursorPagination() {
      this.listCursorTrail = [];
      this.listHasMore = false;
    },
    resolveListHasMore(data) {
      if (data && typeof data.hasMore === "boolean") {
        return data.hasMore;
      }
      const next = data && data.nextSearchAfter;
      if (next == null) {
        return false;
      }
      if (Array.isArray(next)) {
        return next.length > 0;
      }
      if (typeof next === "object") {
        return Object.keys(next).length > 0;
      }
      return !!next;
    },
    clearListRefreshTimer() {
      if (this._listRefreshTimer != null) {
        clearTimeout(this._listRefreshTimer);
        this._listRefreshTimer = null;
      }
    },
    /** 写操作成功后再拉列表，延迟一小段时间以拿到服务端最新状态 */
    queryListAfterMutation() {
      this.clearListRefreshTimer();
      this.loading = true;
      this._listRefreshTimer = setTimeout(() => {
        this._listRefreshTimer = null;
        this.queryList();
      }, LIST_REFRESH_AFTER_MUTATION_MS);
    },
    queryList() {
      const pn = Number(this.queryParam.pageNum) || 1;
      if (pn >= 2) {
        const cursor = this.listCursorTrail[pn - 2];
        if (cursor === undefined || cursor === null) {
          this.$message.warning("分页游标缺失，已回到第一页");
          this.queryParam.pageNum = 1;
          this.resetListCursorPagination();
        }
      }
      this.loading = true;
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v70300/community/dynamic/list",
        body: JSON.stringify(this.buildQueryBody()),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (!this.isRequestSuccess(result.error)) {
            this.$message.error(result.message || "查询失败");
            this.total = 0;
            this.listData = [];
            this.listHasMore = false;
            return;
          }
          const data = result.data || {};
          const list = data.list || [];
          this.total = Number(data.totalCount || 0);
          this.listData = list.map((item) => this.formatItem(item));
          this.selectedRows = [];
          const pageNow = Number(this.queryParam.pageNum) || 1;
          this.listHasMore = this.resolveListHasMore(data);
          const nextSa = data.nextSearchAfter;
          if (nextSa !== undefined) {
            this.$set(this.listCursorTrail, pageNow - 1, nextSa);
          }
        })
        .catch(() => {
          this.$message.error("查询失败");
          this.total = 0;
          this.listData = [];
          this.selectedRows = [];
          this.listHasMore = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatItem(item) {
      const images = Array.isArray(item.images)
        ? item.images.filter(Boolean)
        : [];
      let mediaInfoDisplay;
      if (item.videoUrl) {
        mediaInfoDisplay = this.formatDuration(item.videoDuration);
      } else if (images.length > 0) {
        mediaInfoDisplay = images.length;
      } else {
        mediaInfoDisplay = "--";
      }
      const topics = (item.topics || [])
        .map((topic) => topic.topicName)
        .filter(Boolean);
      const runRecord = this.buildRunRecordDisplay(item);
      return {
        ...item,
        images,
        mediaInfo: mediaInfoDisplay,
        mediaInfoDisplay,
        topicNames: topics.length ? topics.join("、") : "--",
        hasRunRecord: runRecord.hasRunRecord,
        runRecordLine1: runRecord.line1,
        runRecordLine2: runRecord.line2,
        publishedAtText: item.publishedAt
          ? this.formatDateTime(item.publishedAt)
          : "--",
        statusText: this.resolveStatusText(item.status),
        auditReasonDisplay: this.formatAuditReasonDisplay(item.auditMsg),
        isHandpickText: Number(item.isHandpick) === 1 ? "是" : "否",
        authorTypeText: this.resolveAuthorTypeText(item.authorType),
        shareCount: Number(item.shareCount || 0),
        likeCount: Number(item.likeCount || 0),
        commentCount: Number(item.commentCount || 0),
        viewCount: Number(item.viewCount || 0),
        isPinned: Number(item.isPinned) === 1 ? 1 : 0,
        pinStartTimeText: item.pinStartTime
          ? this.formatDateTime(item.pinStartTime)
          : "",
        pinEndTimeText: item.pinEndTime
          ? this.formatDateTime(item.pinEndTime)
          : "",
      };
    },
    formatAuditReasonDisplay(value) {
      if (value === undefined || value === null) {
        return "";
      }
      const s = String(value).trim();
      return s;
    },
    resolveStatusText(status) {
      const value = Number(status);
      if (value === 2) {
        return "审核中";
      }
      if (value === 3) {
        return "通过";
      }
      if (value === 4) {
        return "未通过";
      }
      if (value === 5) {
        return "待发布";
      }
      return "--";
    },
    resolveAuthorTypeText(authorType) {
      const map = {
        1: "普通用户",
        2: "马甲号",
        3: "官方号",
        4: "校园主理人",
      };
      return map[authorType] || "--";
    },
    formatDuration(seconds) {
      const total = Number(seconds || 0);
      if (!total) {
        return "00:00";
      }
      const minute = Math.floor(total / 60);
      const second = total % 60;
      return (
        String(minute).padStart(2, "0") + ":" + String(second).padStart(2, "0")
      );
    },
    isDynamicApproved(row) {
      return Number(row && row.status) === 3;
    },
    resolveRunModeText(runModeEnum) {
      const mode = Number(runModeEnum);
      if (mode === 6) {
        return "户外跑";
      }
      if (mode === 1 || mode === 4) {
        return "校园跑";
      }
      return "--";
    },
    formatRunDuration(totalTime) {
      const total = Math.max(0, Math.floor(Number(totalTime) || 0));
      if (!total) {
        return "--";
      }
      const hour = Math.floor(total / 3600);
      const minute = Math.floor((total % 3600) / 60);
      const second = total % 60;
      if (hour > 0) {
        return `${String(hour).padStart(2, "0")}:${String(minute).padStart(
          2,
          "0"
        )}:${String(second).padStart(2, "0")}`;
      }
      return `${String(minute).padStart(2, "0")}:${String(second).padStart(
        2,
        "0"
      )}`;
    },
    formatRunPace(speed) {
      const val = Number(speed);
      if (isNaN(val) || val <= 0) {
        return "--";
      }
      let minute = Math.floor(val);
      let second = Math.round((val - minute) * 60);
      if (second >= 60) {
        minute += 1;
        second = 0;
      }
      return `${minute}'${String(second).padStart(2, "0")}''`;
    },
    formatRunDistance(totalDis) {
      const meters = Number(totalDis);
      if (isNaN(meters) || meters <= 0) {
        return "";
      }
      const km = meters / 1000;
      return `${km.toFixed(2)}公里`;
    },
    buildRunRecordDisplay(item) {
      const runData = item && item.runData;
      const sportsRecordId =
        (runData && runData.sportsRecordId) || item.sportsRecordId;
      if (!runData && !sportsRecordId) {
        return { hasRunRecord: false, line1: "", line2: "" };
      }
      const modeText = this.resolveRunModeText(runData && runData.runModeEnum);
      const distanceText = this.formatRunDistance(runData && runData.totalDis);
      const durationText = this.formatRunDuration(runData && runData.totalTime);
      const paceText = this.formatRunPace(runData && runData.speed);
      const calorieVal = Number(runData && runData.calorie);
      const calorieText =
        !isNaN(calorieVal) && calorieVal > 0 ? `${calorieVal}千卡` : "";
      const hasRunRecord = !!(
        sportsRecordId ||
        distanceText ||
        durationText !== "--" ||
        paceText !== "--" ||
        calorieText
      );
      if (!hasRunRecord) {
        return { hasRunRecord: false, line1: "", line2: "" };
      }
      const line1Parts = [];
      if (modeText && modeText !== "--") {
        line1Parts.push(modeText);
      }
      if (distanceText) {
        line1Parts.push(distanceText);
      }
      const line2Parts = [];
      if (durationText && durationText !== "--") {
        line2Parts.push(`时长${durationText}`);
      }
      if (paceText && paceText !== "--") {
        line2Parts.push(`配速${paceText}`);
      }
      if (calorieText) {
        line2Parts.push(`消耗${calorieText}`);
      }
      return {
        hasRunRecord: true,
        line1: line1Parts.length ? line1Parts.join(" ") : "--",
        line2: line2Parts.length ? line2Parts.join(" ") : "--",
      };
    },
    vestListAccountType(publishAuthorType) {
      const map = { 2: 1, 3: 3, 4: 4 };
      return map[publishAuthorType] != null ? map[publishAuthorType] : 1;
    },
    resetCommentDialog() {
      this.commentDialog.dynamicId = null;
      this.commentDialog.publishAuthorType = 2;
      this.commentDialog.publishUid = null;
      this.commentDialog.content = "";
      this.commentAccountSearchMode = "name";
      this.commentAccountKeyword = "";
      this.commentAccountOptions = [];
      this.commentEmojiPanelVisible = false;
    },
    onCommentDialogClose() {
      this.resetCommentDialog();
      this.commentSubmitting = false;
    },
    openCommentDialog(row) {
      if (!row || !row.id) {
        return;
      }
      if (!this.isDynamicApproved(row)) {
        this.$message.warning("仅审核通过的动态可评论");
        return;
      }
      this.resetCommentDialog();
      this.commentDialog.dynamicId = row.id;
      this.commentDialog.visible = true;
      this.queryCommentBurnerAccount("");
    },
    onCommentAuthorTypeChange() {
      this.commentDialog.publishUid = null;
      this.commentAccountOptions = [];
      this.commentAccountKeyword = "";
      this.queryCommentBurnerAccount("");
    },
    onCommentAccountSearchModeChange() {
      this.queryCommentBurnerAccount(this.commentAccountKeyword);
    },
    onCommentAccountSelectClear() {
      this.queryCommentBurnerAccount(this.commentAccountKeyword);
    },
    queryCommentBurnerAccount(value) {
      const keyword = String(value || "").trim();
      this.commentAccountKeyword = keyword;
      this.commentSelectLoading = true;
      const param = {
        pageNum: 1,
        pageSize: 50,
        accountType: this.vestListAccountType(
          this.commentDialog.publishAuthorType
        ),
      };
      if (keyword) {
        if (this.commentAccountSearchMode === "name") {
          param.name = keyword;
        } else {
          const n = Number(keyword);
          param.uid = isNaN(n) ? keyword : n;
        }
      }
      this.$http({
        url: this.$util.domain + "/adminapi/v1/operate/v2/vests/list",
        method: "POST",
        body: JSON.stringify(param),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          const data = result.data || {};
          this.commentAccountOptions = data.list || [];
        })
        .catch(() => {
          this.commentAccountOptions = [];
        })
        .finally(() => {
          this.commentSelectLoading = false;
        });
    },
    insertCommentEmoji(emoji) {
      const prev = String(this.commentDialog.content || "");
      if (prev.length >= 500) {
        this.$message.warning("评论内容最多500字");
        return;
      }
      this.commentDialog.content = prev + emoji;
    },
    submitComment() {
      const dynamicId = this.commentDialog.dynamicId;
      const userId = this.commentDialog.publishUid;
      const content = String(this.commentDialog.content || "").trim();
      if (!dynamicId) {
        this.$message.warning("动态信息缺失");
        return;
      }
      if (userId === null || userId === undefined || userId === "") {
        this.$message.warning("请选择评论账号");
        return;
      }
      if (!content) {
        this.$message.warning("请输入评论内容");
        return;
      }
      const payload = {
        dynamicId: Number(dynamicId),
        userId: Number(userId),
        content,
      };
      console.log(LOG_TAG_DYNAMIC_COMMENT, "publishComment submit", {
        dynamicId: payload.dynamicId,
        userId: payload.userId,
        contentLength: content.length,
      });
      this.commentSubmitting = true;
      this.$http({
        method: "POST",
        url:
          this.$util.domain +
          "/adminapi/v70300/community/dynamic/publishComment",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (this.isRequestSuccess(result.error)) {
            this.$message.success("评论发布成功");
            this.commentDialog.visible = false;
            this.queryListAfterMutation();
            return;
          }
          this.$message.error(result.message || "评论发布失败");
        })
        .catch(() => {
          this.$message.error("评论发布失败");
        })
        .finally(() => {
          this.commentSubmitting = false;
        });
    },
    formatDateTime(value) {
      if (!value) {
        return "";
      }
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return String(value);
      }
      const yyyy = date.getFullYear();
      const MM = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const hh = String(date.getHours()).padStart(2, "0");
      const mm = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows || [];
    },
    changeStatus(status) {
      this.currentStatus = status;
      this.resetListCursorPagination();
      this.queryParam.pageNum = 1;
      this.queryList();
    },
    handleSortChange(sortInfo) {
      const sortFieldMap = {
        publishedAt: {
          ascending: 1,
          descending: 2,
        },
        likeCount: {
          ascending: 3,
          descending: 4,
        },
        commentCount: {
          ascending: 5,
          descending: 6,
        },
        viewCount: {
          ascending: 7,
          descending: 8,
        },
        // 分享数排序：后端 sortType 文档暂未列出，暂用 9/10（待后端确认）
        shareCount: {
          ascending: 9,
          descending: 10,
        },
      };
      if (
        !sortInfo ||
        !sortInfo.prop ||
        !sortInfo.order ||
        !sortFieldMap[sortInfo.prop]
      ) {
        this.queryParam.sortType = 0;
      } else {
        this.queryParam.sortType =
          sortFieldMap[sortInfo.prop][sortInfo.order] || 0;
      }
      this.resetListCursorPagination();
      this.queryParam.pageNum = 1;
      this.queryList();
    },
    clickSearch() {
      if (this.queryParam.publishTimeStart && this.queryParam.publishTimeEnd) {
        const startTime = new Date(this.queryParam.publishTimeStart).getTime();
        const endTime = new Date(this.queryParam.publishTimeEnd).getTime();
        if (startTime > endTime) {
          this.$message.warning("发布时间开始时间不能大于结束时间");
          return;
        }
      }
      this.resetListCursorPagination();
      this.queryParam.pageNum = 1;
      this.queryList();
    },
    clickReset() {
      this.queryParam = this.getDefaultQueryParam();
      this.currentStatus = 0;
      this.selectedRows = [];
      this.resetListCursorPagination();
      this.queryList();
    },
    changeCurrentPage(pageNum) {
      const target = Number(pageNum);
      const current = Number(this.queryParam.pageNum) || 1;
      if (target === current) {
        return;
      }
      if (target === 1) {
        this.resetListCursorPagination();
        this.queryParam.pageNum = 1;
        this.queryList();
        return;
      }
      if (target === current + 1) {
        if (!this.listHasMore) {
          this.$message.warning("当前已是最后一页");
          return;
        }
        const cursor = this.listCursorTrail[current - 1];
        if (cursor === undefined || cursor === null) {
          this.$message.warning("分页游标缺失，请从第一页重新查询");
          this.resetListCursorPagination();
          this.queryParam.pageNum = 1;
          this.queryList();
          return;
        }
        this.queryParam.pageNum = target;
        this.queryList();
        return;
      }
      if (target === current - 1 && current > 1) {
        this.queryParam.pageNum = target;
        this.queryList();
        return;
      }
      this.$message.warning("游标分页不支持跳页，请使用上一页、下一页逐页查看");
    },
    goAddDynamic() {
      this.$router.push({ path: "/yunying/dynamic/manage/detail" });
    },
    getSelectedIds() {
      return this.selectedRows.map((item) => item.id).filter(Boolean);
    },
    resetAuditDialogRejectFields() {
      this.auditDialog.rejectReasonKey = "";
      this.auditDialog.rejectReasonExtra = "";
    },
    /** 切换事由类型时，非「其他」清空自定义框内容，避免误带上一档内容 */
    onAuditRejectReasonKeyChange() {
      if (this.auditDialog.rejectReasonKey !== this.auditRejectReasonOtherKey) {
        this.auditDialog.rejectReasonExtra = "";
      }
    },
    onAuditDialogStatusChange(val) {
      if (Number(val) !== 2) {
        this.resetAuditDialogRejectFields();
      }
    },
    /** 不通过时 auditReason：预设项提交对应文案；仅「其他」展示输入框并提交自定义（≤50字） */
    buildAuditReasonForSubmit() {
      if (Number(this.auditDialog.auditStatus) !== 2) {
        return undefined;
      }
      const key = this.auditDialog.rejectReasonKey;
      if (!key) {
        return undefined;
      }
      if (key === this.auditRejectReasonOtherKey) {
        const text = String(this.auditDialog.rejectReasonExtra || "")
          .trim()
          .slice(0, 50);
        return text || undefined;
      }
      const opt = this.auditRejectReasonOptions.find((o) => o.key === key);
      return opt ? opt.label : undefined;
    },
    openBatchAuditDialog() {
      if (!this.selectedRows.length) {
        this.$message.warning("请先选择动态");
        return;
      }
      this.auditDialog.auditStatus = 1;
      this.resetAuditDialogRejectFields();
      this.auditDialog.visible = true;
    },
    openBatchHandpickDialog() {
      if (!this.selectedRows.length) {
        this.$message.warning("请先选择动态");
        return;
      }
      this.handpickDialog.isHandpick = 1;
      this.handpickDialog.visible = true;
    },
    openSingleAudit(row) {
      this.selectedRows = [row];
      this.auditDialog.auditStatus = 1;
      this.resetAuditDialogRejectFields();
      this.auditDialog.visible = true;
    },
    openSingleHandpick(row) {
      this.selectedRows = [row];
      this.handpickDialog.isHandpick = Number(row.isHandpick) === 1 ? 0 : 1;
      this.handpickDialog.visible = true;
    },
    /** 打开置顶弹窗：与精选一致，默认取当前状态的相反值（已置顶→取消置顶） */
    openPinDialog(row) {
      if (!row || !row.id) {
        return;
      }
      const pinned = Number(row.isPinned) === 1;
      this.pinDialog.dynamicId = row.id;
      this.pinDialog.isPin = pinned ? 0 : 1;
      this.pinDialog.pinTime = "";
      if (pinned && row.pinStartTime && row.pinEndTime) {
        const start = new Date(row.pinStartTime);
        const end = new Date(row.pinEndTime);
        if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
          this.pinDialog.pinTime = [start, end];
        }
      }
      this.pinDialog.visible = true;
    },
    /** 置顶/取消置顶：POST /adminapi/v70300/community/dynamic/pin */
    submitPin() {
      const dynamicId = this.pinDialog.dynamicId;
      if (!dynamicId) {
        this.$message.warning("动态信息缺失");
        return;
      }
      const isPin = Number(this.pinDialog.isPin);
      const payload = {
        dynamicId: Number(dynamicId),
        isPin,
      };
      if (isPin === 1) {
        const range = this.pinDialog.pinTime;
        if (!Array.isArray(range) || !range[0] || !range[1]) {
          this.$message.warning("请选择置顶时间");
          return;
        }
        const startMs = new Date(range[0]).getTime();
        const endMs = new Date(range[1]).getTime();
        if (isNaN(startMs) || isNaN(endMs)) {
          this.$message.warning("置顶时间格式不正确");
          return;
        }
        if (endMs <= startMs) {
          this.$message.warning("置顶结束时间需晚于开始时间");
          return;
        }
        payload.pinStartTime = this.formatDateTime(range[0]);
        payload.pinEndTime = this.formatDateTime(range[1]);
      }
      this.pinSubmitting = true;
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v70300/community/dynamic/pin",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (this.isRequestSuccess(result.error)) {
            this.$message.success("操作成功");
            this.pinDialog.visible = false;
            this.queryListAfterMutation();
            return;
          }
          this.$message.error(result.message || "操作失败");
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          this.pinSubmitting = false;
        });
    },
    submitBatchAudit() {
      const idList = this.getSelectedIds();
      if (!idList.length) {
        this.$message.warning("请先选择动态");
        return;
      }
      const auditReason = this.buildAuditReasonForSubmit();
      const payload = {
        idList,
        auditStatus: this.auditDialog.auditStatus,
      };
      if (auditReason !== undefined) {
        payload.auditReason = auditReason;
      }
      console.log(LOG_TAG_DYNAMIC_AUDIT, "batchAudit submit", {
        idCount: idList.length,
        auditStatus: payload.auditStatus,
        hasAuditReason: auditReason !== undefined,
      });
      this.loading = true;
      this.$http({
        method: "POST",
        url:
          this.$util.domain + "/adminapi/v70300/community/dynamic/batchAudit",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (this.isRequestSuccess(result.error)) {
            this.$message.success("操作成功");
            this.auditDialog.visible = false;
            this.queryListAfterMutation();
            return;
          }
          this.$message.error(result.message || "操作失败");
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          if (this._listRefreshTimer == null) {
            this.loading = false;
          }
        });
    },
    submitBatchHandpick() {
      const idList = this.getSelectedIds();
      if (!idList.length) {
        this.$message.warning("请先选择动态");
        return;
      }
      this.loading = true;
      this.$http({
        method: "POST",
        url:
          this.$util.domain +
          "/adminapi/v70300/community/dynamic/batchHandPick",
        body: JSON.stringify({
          idList,
          isHandpick: this.handpickDialog.isHandpick,
        }),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (this.isRequestSuccess(result.error)) {
            this.$message.success("操作成功");
            this.handpickDialog.visible = false;
            this.queryListAfterMutation();
            return;
          }
          this.$message.error(result.message || "操作失败");
        })
        .catch(() => {
          this.$message.error("操作失败");
        })
        .finally(() => {
          if (this._listRefreshTimer == null) {
            this.loading = false;
          }
        });
    },
    openImagePreview(row) {
      const urls = (row && row.images) || [];
      if (!urls.length) {
        return;
      }
      this.imagePreview.urls = urls.slice();
      this.imagePreview.index = 0;
      this.imagePreview.visible = true;
    },
    closeImagePreview() {
      this.imagePreview.visible = false;
      this.imagePreview.urls = [];
      this.imagePreview.index = 0;
    },
    shiftImagePreview(delta) {
      const n = this.imagePreview.urls.length;
      if (n <= 1) {
        return;
      }
      this.imagePreview.index = (this.imagePreview.index + delta + n) % n;
    },
    openVideoPreview(row) {
      const url = row && row.videoUrl;
      if (!url) {
        return;
      }
      this.videoPreview.url = url;
      this.videoPreview.poster = row.videoCover || "";
      this.videoPreview.visible = true;
      this.$nextTick(() => {
        const el = this.$refs.previewVideo;
        if (el && typeof el.play === "function") {
          el.play().catch(() => {});
        }
      });
    },
    closeVideoPreview() {
      const el = this.$refs.previewVideo;
      if (el && typeof el.pause === "function") {
        el.pause();
      }
      this.videoPreview.visible = false;
      this.videoPreview.url = "";
      this.videoPreview.poster = "";
    },
    routeDynamicDetail(row) {
      window.open("/#/yunying/community/user/list?uid=" + row.userId);
    },
  },
};
</script>

<style scoped>
.search-wrapper {
  margin-bottom: 8px;
}

.search-row {
  margin-bottom: 0;
}

.search-action-item {
  margin-left: 48px;
}

.range-divider {
  display: inline-block;
  margin: 0 8px;
}

.status-tabs {
  padding: 6px 20px 14px;
}

.status-tabs-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.add-dynamic-btn {
  flex-shrink: 0;
}

.status-tab-group {
  display: inline-flex;
}

.status-tab-btn {
  min-width: 64px;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #409eff;
  border-radius: 0;
  color: #409eff;
  background: #fff;
  font-size: 14px;
}

.status-tab-btn + .status-tab-btn {
  margin-left: -1px;
}

.status-tab-btn:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.status-tab-btn:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.status-tab-btn.is-active {
  background: #409eff;
  color: #fff;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px 0;
  box-sizing: border-box;
}

.bottom-action-wrapper {
  display: flex;
  gap: 10px;
  margin-left: 0;
  flex-shrink: 0;
}

.pagination-seq {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-left: 16px;
  flex: 1;
  min-width: 0;
}

.pagination-seq-hint {
  color: #909399;
  font-size: 13px;
  line-height: 32px;
}

.dialog-tip {
  margin-top: 6px;
  color: #666;
  font-size: 13px;
  line-height: 20px;
}

.audit-reject-form-item >>> .el-form-item__content {
  line-height: normal;
}

.audit-reject-block {
  max-width: 340px;
}

.reject-extra-input {
  margin-top: 10px;
}

.media-info-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.media-info-cell--empty {
  color: #909399;
  font-size: 13px;
}

.media-thumb-wrap {
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
}

.media-thumb {
  display: block;
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 4px;
  background: #f5f7fa;
}

.media-thumb--fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #909399;
}

.media-thumb--video .media-thumb,
.media-thumb--video .media-thumb--fallback {
  vertical-align: top;
}

.media-play-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 1;
  pointer-events: none;
}

.media-thumb-badge {
  position: absolute;
  right: 2px;
  bottom: 2px;
  padding: 0 5px;
  font-size: 11px;
  line-height: 18px;
  color: #fff;
  background: rgba(0, 0, 0, 0.55);
  border-radius: 2px;
  pointer-events: none;
}

.media-info-value {
  font-size: 13px;
  color: #606266;
  min-width: 36px;
  text-align: left;
}

.image-preview-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 12px;
}

.image-preview-counter {
  font-size: 14px;
  color: #606266;
  min-width: 72px;
  text-align: center;
}

.image-preview-body {
  text-align: center;
  min-height: 200px;
}

.image-preview-img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  vertical-align: middle;
}

.video-preview-player {
  display: block;
  width: 100%;
  max-height: 70vh;
  background: #000;
}

.run-record-cell {
  text-align: left;
  font-size: 13px;
  color: #303133;
  line-height: 1.45;
  padding: 2px 4px;
}

.run-record-cell--empty {
  text-align: center;
  color: #909399;
}

.run-record-line + .run-record-line {
  margin-top: 4px;
}

.pin-time-cell {
  padding: 2px 4px;
  font-size: 13px;
  color: #303133;
  line-height: 1.45;
}

.pin-time-line + .pin-time-line {
  margin-top: 2px;
}

.form-item-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.form-item-row__col {
  min-width: 0;
}

.form-item-row__col--author {
  flex: 0 0 132px;
  width: 132px;
}

.form-item-row__col--mode {
  flex: 0 0 118px;
  width: 118px;
}

.form-item-row__col--grow {
  flex: 1 1 auto;
  min-width: 180px;
}

.account-option {
  display: flex;
  align-items: center;
}

.account-option-avatar {
  width: 22px;
  height: 22px;
  margin-right: 8px;
  object-fit: cover;
  border-radius: 2px;
}

.comment-emoji-bar {
  position: relative;
  margin-top: 6px;
}

.comment-emoji-trigger {
  padding: 0;
  color: #909399;
}

.comment-emoji-trigger-icon {
  font-size: 20px;
  line-height: 1;
}

.comment-emoji-panel {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 8px;
  padding: 8px;
  max-width: 360px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
}

.comment-emoji-item {
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  font-size: 18px;
  cursor: pointer;
  border-radius: 4px;
}

.comment-emoji-item:hover {
  background: #ecf5ff;
}
</style>



// WEBPACK FOOTER //
// DynamicManage.vue?27441301